import { Component, OnInit } from '@angular/core';
import { ServiceManagerService } from '../service-manager.service';
import { UserType, HttpMethod } from '../../constants/constant'
import { Router } from '@angular/router';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
@Component({
  selector: 'app-peoples',
  templateUrl: './peoples.component.html',
  styleUrls: ['./peoples.component.scss']
})
export class PeoplesComponent implements OnInit {
  currentUserType: string = UserType.MENTOR;
  currentpage: any = 0;
  maxperpage: Number = 10;
  usersList: any = []
  selectedUsers: any = []
  searchUser: string = '';
  isUserListEmpty: boolean = false;
  isSearched: boolean = false;
  showInactiveUser: boolean = false;
  searchCount:any;
  totalUser:any;
  constructor(public serviceManager: ServiceManagerService, private router: Router) {
    this.checkRouting()
    this.getUserListByType()
  }

  ngOnInit(): void {
  }

  selectAllUser: boolean = false;


  onScroll(event:any) {
    var element: any = document.getElementById("users-card-list")
    var height = element.clientHeight;
    var y = element?.scrollTop;
    let scrollBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
    if ((scrollBottom <= 0 || (scrollBottom > 0 && scrollBottom < 1)) && !this.isUserListEmpty) {
      this.currentpage = this.currentpage + 1
      this.getUsersList()
    }
  }

  getUserListByType(){ 
    this.isUserListEmpty = false
    this.usersList = []
    this.searchUser = '';
    this.selectAllUser = false
    this.currentpage = 0
    this.getUsersList()
  }

  resendActivationCode(userId: any, event: any){
    event.stopPropagation()
    var body = {
      "user_id" : userId
    }
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: true,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI('generate-activation-code', body, HttpMethod.POST, customOptions).subscribe( (data: any)=>{
    }, (error: any) =>{
    })
  }

  getUsersList(){
    var body = {
      "user_type" : this.currentUserType,
      "currentpage": this.currentpage,
      "maxperpage": this.maxperpage,
      "is_activate": !this.showInactiveUser,
      "filters":{
        "search" : this.searchUser.trim()
      }
    }
    this.serviceManager.CallBackendServiceAPI('list-users', body).subscribe( (data: any)=>{
      if(!data.user_list.length)
        this.isUserListEmpty = true
      
      this.usersList = [ ...this.usersList, ...data.user_list];
      this.totalUser = data.total_user
      this.searchCount = data.search_count
      this.updateAllUser()
    })
  }

  deleteUserModel(){
    document.getElementById("deleteModelPopup")?.click();
  }
  deleteUsers(){
    var body = {
      "users_list" : this.selectedUsers
    }
    this.serviceManager.CallBackendServiceAPI('delete-users', body).subscribe( (data: any)=>{
      this.currentpage = 0
      this.usersList = []
      this.getUsersList()
    })
  }

  setUpdateUser(user_id:any){
    this.serviceManager.navigateToPageWithState('/update-people', {user_id : user_id})
  }

  clearSearchUserList(){
    this.isUserListEmpty = false
    this.searchUser = '';
    if(this.isSearched){
      this.currentpage = 0
      this.usersList = []
      this.getUsersList()
    }
    this.isSearched = false
  }

  searchInUserList(){
    this.isUserListEmpty = false
    if(!this.searchUser.trim() && this.isSearched){
      this.selectAllUser = false
      this.isSearched = false
      this.usersList = []
      this.currentpage = 0
      this.getUsersList()
    }
    else if(this.searchUser.trim()){
      this.selectAllUser = false
      this.usersList = []
      this.isSearched = true
      this.currentpage = 0
      this.getUsersList()
    }
  }

  updateAllUser() {
    this.selectAllUser = this.usersList.length && this.usersList.every((user: any) => user.selected);
  }

  checkSelectAll(): boolean {
    if (!this.usersList.length) {
      return false;
    }
    return this.usersList.filter((user : any)=> user.selected).length > 0 && !this.selectAllUser;
  }

  setSelectAllUser(selected: boolean) {
    this.selectAllUser = selected;
    this.selectedUsers = []
    if (this.usersList == null) {
      return;
    }
    this.usersList.forEach((user: any) => (user.selected = selected))
  }

  showDelete(){
    return this.checkSelectAll()||this.selectAllUser
  }
  getSelectedUserCount(){
    this.selectedUsers = this.usersList.filter((user:any) => user.selected).map((user: any)=> user.user_id)
    return this.selectedUsers.length
  }

  getScrollableWidth(){
    var element: any = document.getElementById("users-card-list")
    return element.offsetWidth - element.clientWidth
  }

  addNewPeer(){
    this.router.navigate(['/add-people'])
  }

  checkRouting(){
    let url = this.router.url.split("?")[0]
    if(url === '/'){
      this.router.navigate(['/people'])
    }
  }


  setUsersList(isChecked: any){
    this.usersList = []
    this.showInactiveUser = isChecked
    this.currentpage = 0
    this.getUsersList()
    console.log(isChecked);
    
  }
}
